import type { UserProfile } from "@/app/auth/_modules/types/user";

export const initialUserState: UserProfile = {
  user: {
    id: "",
    subEnd: "",
    accountType: "",
    isTestUser: false,
    isTrialActive: false,
    leadsLight: false,
    userType: "agent",
    name: "",
    email: "",
    contactPhone: "",
    trialExpiresAt: "",
    trialEnd: "",
    isOnline: false,
    createdBy: "",
    updatedAt: "",
    createdAt: "",
    title: null,
    stripeId: null,
    weeklyRep: null,
    sockId: null,
    compLevel: null,
    upLine: null,
    lastSeenAt: null,
    emailVerifiedAt: null,
    companyId: null,
    reissueEnabledAt: null,
    callForwardingEnabledAt: null,
    deletedAt: null,
    hasUsedTrial: false,
    dailyImportsCount: 0,
    autoBillingEnabled: false,
    trialUpgradeOptIn: false,
    accountStatus: "active",
  },
  trialExpiresAt: "",
  isTrialActive: false,
  accountTypeInfo: {
    type: "",
    name: "",
    description: "",
    hasTrial: false,
    trialDays: 0,
    features: [],
  },
};
